<template>
  <div class="animated">
    <v-client-table
      :columns="columns"
      :data="samples"
      :options="options"
      :theme="theme"
      id="sample-table"
      class="w-100"
    >
      <span slot="number" slot-scope="{ row }">
        <a :href="'#/samples/' + row.id">
          {{ row.number }}
        </a>
      </span>

      <span slot="customer" slot-scope="{ row }">
        {{ row.submission.project.customer.full_name }}
      </span>

      <span slot="sample_type" slot-scope="{ row }">
        {{ row.submission.sample_type["name"] }}
      </span>

      <span slot="status" slot-scope="{ row }">
        {{ getStatus(row) }}
      </span>

      <span slot="date" slot-scope="{ row }">
        {{ row.created_at }}
      </span>

      <span slot="actions" slot-scope="{ row }">
        <a
          v-if="getStatus(row) === 'Sent'"
          class="btn btn-success px-1 py-0 text-white mr-1"
          @click="markReceived(row.id)"
        >
          <i class="fa fa-barcode"></i>
        </a>
        <a
          class="btn btn-info px-1 py-0 text-white mr-1"
          :href="'#/samples/' + row.id"
        >
          <i class="fa fa-eye"></i>
        </a>
        <a
          class="btn btn-warning px-1 py-0 text-white mr-1"
          :href="'#/samples/' + row.id + '/edit'"
        >
          <i class="fa fa-pencil"></i>
        </a>
        <a
          v-if="getStatus(row) === 'Open'"
          class="btn btn-info px-1 py-0 text-white mr-1"
          @click="markSent(row.id)"
        >
          <i class="fa fa-envelope"></i>
        </a>
        <a
          class="btn btn-danger px-1 py-0 text-white mr-1"
          @click="showDeleteModal(row.id)"
        >
          <i class="fa fa-trash"></i>
        </a>
      </span>
    </v-client-table>
  </div>
</template>

<script>
import Vue from "vue";
import { ClientTable, Event } from "vue-tables-2";

Vue.use(ClientTable);

export default {
  name: "SampleTable",
  components: {
    ClientTable,
    Event,
  },
  props: {
    /** rows array */
    samples: {
      type: Array,
    },
    /** column include/display order array */
    show_columns: {
      type: Array,
      default: () => [
        "number",
        "customer",
        "sample_type",
        "status",
        "date",
        "actions",
      ],
    },
    /** filterable column array */
    filterable: {
      type: Array,
      default: () => ["number", "customer", "sample_type", "status", "date"],
    },
  },
  data() {
    return {
      columns: this.show_columns,
      data: this.samples,
      options: {
        headings: {
          number: "Number",
          customer: "Customer",
          sample_type: "Sample Type",
          location: "Location",
          status: "Status",
          date: "Date",
        },
        sortable: ["number", "customer", "sample_type", "status", "date"],
        filterable: this.filterable,
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort",
        },
        pagination: {
          chunk: 5,
          edge: false,
          nav: "scroll",
        },
      },
      useVuex: false,
      theme: "bootstrap4",
      template: "default",
    };
  },
  methods: {
    getStatus(row) {
      return row["current_sample_status_log"]["sample_status"]["status"];
    },
    getSampleCount(row) {
      return row["samples"].length;
    },
    showDeleteModal(id) {
      this.$bvModal
        .msgBoxConfirm(
          "You are about to remove this sample. Do you want to continue?",
          {
            title: "Are you sure?",
            modalClass: ["modal-danger"],
            size: "sm",
            okVariant: "danger",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            centered: true,
          }
        )
        .then((data) => {
          this.$emit("deleteSample", id);
        });
    },
    markSent(id) {
      this.$emit("markSent", id);
    },
    markReceived(id) {
      this.$emit("markReceived", id);
    },
  },
};
</script>
